import {chain, filter, map, pipe, prop, set, propEq, lensProp} from 'ramda';

const filterSelected = filter(prop('selected'));
const getValues = chain(prop('value'));
const getNames = map(prop('name'));

export const getActiveFilters = pipe(filterSelected, getValues);
export const getBiosFilters = pipe(filterSelected, getValues, filter(el => !!el));
export const getSelectedFilterNames = pipe(prop('filters'), filterSelected, getNames);
export const getSelectedFilterValue = pipe(prop('filters'), filterSelected, getValues);


// enableFilters :: [Filter] -> [Filter]
export const enableFilters = map(set(lensProp('disabled'), false));

// disableFilters :: [Filter] -> [Filter]
export const disableFilters = map(set(lensProp('disabled'), true));

export const unselectFilters = map(set(lensProp('selected'), false));

export const getPackageTypeFilterValue = ({packageType}) => {
  return getActiveFilters(packageType.filters);
};

export const getStatusFilterValue = ({status}) => {
  if (status) {
    const activeStatuses = getActiveFilters(status.filters);
    return activeStatuses.length ? {status: activeStatuses} : {};
  } else {
    return {};
  }
};

export const getStationFilterValue = query => {
  const selected = query.scope.filters.find(f => f.selected);
  return selected ? selected.value : undefined;
};

export const getMyMediaFilterValue = query => {
  const selected = query?.myMedia?.filters?.find(f => f.selected);
  return selected ? selected.value : undefined;
};

export const getDateObj = query => ({
  dateFrom: query.fromDate || null,
  dateThru: query.thruDate || null,
});

export const getSortColumn = query => {
  if (!query.sortOptions) {
    return null;
  }
  const selectedFilter = filterSelected(query.sortOptions.filters);
  return selectedFilter.length ? selectedFilter[0].sortColumn : null;
};

export const getSortDirection = query => {
  if (!query.sortOptions) {
    return null;
  }
  const selectedFilter = filterSelected(query.sortOptions.filters);
  return selectedFilter.length ? selectedFilter[0].sortDirection : null;
};

export const getBroadcastFilter = ({packageType: {filters}}) =>
  filters.find(propEq('name', 'broadcast'));

export const setBroadcastFilter = (newBroadcastFilter, query) => {
  const packageTypeFilters = query.packageType.filters.map(packageFilter => {
    if (packageFilter.name === 'broadcast') {
      return newBroadcastFilter;
    } else {
      return packageFilter;
    }
  });

  return {
    ...query,
    packageType: {
      ...query.packageType,
      filters: packageTypeFilters,
    },
  };
};

export const mergeFilter = (filterType, filters, query) => {
  return {
    ...query,
    [filterType]: {
      ...query[filterType],
      filters,
    },
  };
};
